import { RadioButton } from "primereact/radiobutton";

export function OptionSelector({
  selectedAbnOption,
  setSelectedAbnOption,
  options,
}: {
  selectedAbnOption: string;
  setSelectedAbnOption: (option: string) => void;
  options: {
    label: string;
    value: string;
  }[];
}) {
  return (
    <div className="flex flex-column gap-3">
      <p className="text-sm font-semibold dark-gray">Choose one option:</p>
      <div className="flex flex-column gap-3">
        {options.map((option) => (
          <div
            className="flex flex-row gap-2 border-1 border-round-md p-2 cursor-pointer"
            style={{ borderColor: "#e2e2e4" }}
            onClick={() => setSelectedAbnOption(option.value)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                setSelectedAbnOption(option.value);
              }
            }}
          >
            <RadioButton
              key={option.value}
              value={option.value}
              onChange={(e) => setSelectedAbnOption(e.value)}
              checked={selectedAbnOption === option.value}
            />
            <p className="text-sm gray">{option.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
